<template>
  <div class="about">
    <div class="banner_page">
      <img src="../../assets/img/banner/banner_news.jpg" alt="">
    </div>
    <div class="container_wrap">
      <el-row :gutter="30">
        <el-col :span="5">
          <div class="side_hd">
            <h2>新闻资讯</h2>
            <p>NEWS</p>
          </div>
          <div class="side_wrap">
            <ul>
              <li v-for="(item,index) in sideNav" :class="{'active' : cur == index}" :key="index" @click="cur=index">
                <router-link :to="item.href">{{item.name}}</router-link>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="contTit">
            <h2>新闻资讯</h2>
            <p><router-link to="/">首页</router-link> · <router-link to="/news">新闻资讯</router-link> · <span>{{titleRight}}</span></p>
          </div>
          <div class="contRWrap">
            <router-view />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  data(){
    return{
      cur: 0,
      sideNav: [
        {
          name: '集团动态',
          href: '/news'
        },
        {
          name: '公司动态',
          href: '/news/bases'
        },
        {
          name: '基层动态',
          href: '/news/notice'
        }
      ],
      titleRight: '集团动态'
    }
  },
  created: function(){
    var _this = this
    if(_this.$route.meta){
      _this.cur = _this.$route.meta.sub ? _this.$route.meta.sub : 0
      _this.titleRight = _this.sideNav[_this.cur].name
    }
  },
  watch: {
    '$route': function () {
      if(this.$route.meta){
        this.cur = this.$route.meta.sub ? this.$route.meta.sub : 0
        this.titleRight = this.sideNav[this.cur].name
      }
    }
  }
}
</script>
